import { render, staticRenderFns } from "./AccountBalanceWidget.vue?vue&type=template&id=e9b37216&scoped=true"
import script from "./AccountBalanceWidget.vue?vue&type=script&lang=ts"
export * from "./AccountBalanceWidget.vue?vue&type=script&lang=ts"
import style0 from "./AccountBalanceWidget.vue?vue&type=style&index=0&id=e9b37216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b37216",
  null
  
)

export default component.exports